import { useState } from 'react'
import * as Styles from './Tabs.style'
import Text from 'src/components/atoms/Text/Text'
import { AnimatePresence, motion } from 'framer-motion'
import RichText from 'src/components/atoms/RichText/RichText'
import Button from 'src/components/atoms/Button/Button'

type TabsProps = {
    items: {
        title: string
        content: string
    }[]
}

const Tabs: React.FC<TabsProps> = ({ items }) => {
    const [currentIndex, setCurrentIndex] = useState(0)

    return (
        <Styles.Wrapper>
            <Styles.TitleWrapper>
                {items.map(({ title }, index) => (
                    <Button
                        aria-label={title}
                        css={{
                            opacity: currentIndex !== index ? 0.6 : 1,
                            transition: 'opacity 0.2s linear',
                            '&::after': {
                                display: 'none',
                            },
                        }}
                        onClick={() => {
                            setCurrentIndex(index)
                        }}
                    >
                        {title}
                    </Button>
                ))}
            </Styles.TitleWrapper>
            <div>
                <AnimatePresence exitBeforeEnter>
                    <motion.div
                        key={currentIndex}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <RichText htmlString={items[currentIndex].content} />
                    </motion.div>
                </AnimatePresence>
            </div>
        </Styles.Wrapper>
    )
}

export default Tabs
